"use client";

import styles from "./ForgotPasswordSubmitButton.module.scss";

import { useForgotPasswordForm } from "../../_hooks";
import { useTranslations } from "@/i18n";
import { Button } from "@vetty/ui";

/**
 * ForgotPasswordSubmitButton Component
 *
 * Submit button for forgot password form using custom hook for logic.
 * Simplified component that delegates all logic to useForgotPasswordForm hook.
 */
export const ForgotPasswordSubmitButton = () => {
  const t = useTranslations("forgotPassword.form");

  // Get forgot password functionality from custom hook
  const { submitForgotPassword, loading } = useForgotPasswordForm();

  return (
    <Button
      disabled={loading}
      loading={loading}
      onClick={submitForgotPassword}
      className={styles["comp"]}
    >
      {t("sendRequest")}
    </Button>
  );
};
